import styled from 'styled-components';
import {dFlex, dFlexCenter, alignCenter, justifyBetween} from '../../../../../../globalVariables/GlobalFlex';
import {BGImageCenter, ellipsisLines, LIGHT_BLUE7, BORDER_GRAY, HOVER_BLUE, WHITE, GRAY, LIGHT_GRAY, MANDATORY_BG, OPTIONAL_PURPLE_BG, LIGHT_GRAY2, STATUS_ACTIVE_BG, STATUS_ACTIVE_TEXT, STATUS_INACTIVE_BG, STATUS_INACTIVE_TEXT, STATUS_EXPIRED_BG, STATUS_EXPIRED_TEXT, STATUS_DRAFT_BG, STATUS_DRAFT_TEXT, HOVER_BLUE_SHADOW, mobileMedia, ellipsis} from '../../../../../../globalVariables/GlobalVariables';
import {arrowDown} from '../../../../../../assets/symbols/symbols/Symbols.css';

export const eventItem = styled.div<{selected: boolean; disabled?: boolean}>`
    ${dFlex}
    border: 0.5px solid ${BORDER_GRAY};
    border-radius: 53px;
    margin-bottom: 8px;
    padding: 8px 12px;
    background: ${props => props.selected ? LIGHT_BLUE7 : WHITE};
    transition: all 0.3s ease;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    opacity: ${props => props.disabled ? 0.6 : 1};
    ${alignCenter}
    gap: 10px;
    ${justifyBetween}

    &:hover {
        ${props => !props.disabled && `
            border-color: ${HOVER_BLUE};
            box-shadow: 0 2px 8px ${HOVER_BLUE_SHADOW};
        `}
    }
    ${mobileMedia}{
        padding: 4px;
        gap: 4px;
        border-radius: 15px;
    }
`;

export const image = styled.div<{image?: string}>`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-image: url(${props => props.image || ''});
    background-size: cover;
    background-position: center;
    background-color: ${LIGHT_GRAY2};
    flex-shrink: 0;
`;
export const select = styled.div`
    width: 60px;
    position: relative;
    ${dFlex}
    ${alignCenter}
    gap: 8px;
    ${mobileMedia}{
        width: 40px;
        gap: 2px;
    }
`;

export const successIcon = styled.div`
    ${dFlexCenter}
    margin-inline-end: 4px;
    height: 18px;
    width: 18px;
`;
export const state = styled.div`
    position: relative;
    width: 80px;
`;
export const eventKindButton = styled.button<{eventKind: string | null}>`
    padding: 0 6px;
    border: 1px solid ${LIGHT_GRAY};
    border-radius: 8px;
    
    background: ${props => {
    if(props.eventKind === 'mandatory') return MANDATORY_BG;
    if(props.eventKind === 'optional') return OPTIONAL_PURPLE_BG;
    return WHITE;
}};
    cursor: pointer;
    
    &:disabled {
        background: ${LIGHT_GRAY2};
        cursor: not-allowed;
    }
    
    &:focus {
        outline: none;
        border-color: ${HOVER_BLUE};
    }
`;

export const eventKindContent = styled.div`
    ${dFlex}
    ${alignCenter}
    ${justifyBetween}
    gap: 4px;
    height: 24px;
    ${ellipsis}
    &::after {
        content: '';
        height: 15px;
        width: 15px;
        ${BGImageCenter(arrowDown)} 
    }
`;
export const title = styled.div`
    font-weight: 500;
    text-align: start;
    width: 120px;
    ${ellipsisLines(2)}
    ${mobileMedia}{
        width: 100%;
    }
`;

export const date = styled.div`
    text-align: center;
    width: 80px;
`;

export const time = styled.div`
    text-align: center;
    width: 50px;
`;

export const locationText = styled.div`
    width: 100%;
    max-width: 100px;
`;

export const category = styled.div`
    text-align: center;
    padding: 4px 8px;
    border-radius: 4px;
    width: 100%;
    max-width: 100px;
`;

export const statusBadge = styled.div<{status: string}>`
    padding: 4px 8px;
    border-radius: 12px;
    font-weight: 400;
    text-align: center;
    color: ${props => {
    switch (props.status) {
        case 'active': return STATUS_ACTIVE_TEXT;
        case 'inactive': return STATUS_INACTIVE_TEXT;
        case 'expired': return STATUS_EXPIRED_TEXT;
        case 'draft': return STATUS_DRAFT_TEXT;
        default: return GRAY;
    }
}};
    background: ${props => {
    switch (props.status) {
        case 'active': return STATUS_ACTIVE_BG;
        case 'inactive': return STATUS_INACTIVE_BG;
        case 'expired': return STATUS_EXPIRED_BG;
        case 'draft': return STATUS_DRAFT_BG;
        default: return GRAY;
    }
}};
`;
